export enum CourseTranslationTags {
  CourseName = "course_name",
}
